import React from 'react'
import { connect } from 'react-redux'
import $ from 'jquery'

import {
    fetchBidsMngtList,
    addBidOption,
    selAllBidOptions,
    selSelBidOptions,
    unSelBidOption,
    unSelAllBidOptions,
    selAllArchiveOptions,
    selSelArchiveOptions,
    unSelArchiveOption,
    unSelAllArchiveOptions,
    updateBids,
    fetchBidsMngtError,
    errorBidsMngt
} from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './BidTracker.css'

var Spinner = require('react-spinkit');

let chkReturn = 0;

class Bids extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            notify: false,
            curProp: 'bidStatuses'
        };

        this.fetchBidsMngtErrorClear = this.fetchBidsMngtErrorClear.bind(this);

        this.errorBidMngtClear = this.errorBidMngtClear.bind(this);

        this.newProp = this.newProp.bind(this);

        this.emailChange = this.emailChange.bind(this);

        this.addOption = this.addOption.bind(this);

        this.optSelect = this.optSelect.bind(this);
        this.selAll = this.selAll.bind(this);
        this.selSel = this.selSel.bind(this);
        this.unSel = this.unSel.bind(this);
        this.unSelAll = this.unSelAll.bind(this);

        this.selAll2 = this.selAll2.bind(this);
        this.selSel2 = this.selSel2.bind(this);
        this.unSel2 = this.unSel2.bind(this);
        this.unSelAll2 = this.unSelAll2.bind(this);

        this.onSubmit = this.onSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onCancelNotify = this.onCancelNotify.bind(this);

        this.cancelBids = this.cancelBids.bind(this);
        this.closeBids = this.closeBids.bind(this);
    }

    componentDidMount() {
        var opts = document.getElementById('options')
        var opts2 = document.getElementById('options2')

        setTimeout(function () {
            opts.size = opts.length
            opts2.size = opts2.length
        }, 1000)
    }

    fetchBidsMngtErrorClear() {
        this.props.dispatch(fetchBidsMngtError);
    }

    errorBidMngtClear() {
        this.props.dispatch(errorBidsMngt);
    }

    newProp(e) {
        var opts = document.getElementById('options')
        var opts2 = document.getElementById('options2')

        $('input#newavail').val('')
        this.setState({ curProp: e.target.value })

        if (e.target.value == "states")
            $('.newavail').attr('disabled', 'disabled')
        else
            $('.newavail').removeAttr('disabled')

        $('li').each(function () {
            $(this).removeClass('selected');
        })

        setTimeout(function () {
            opts.size = opts.length
            opts2.size = opts2.length
        }, 100)
    }

    addOption() {
        if (this.props.bids.fetching) return

        if ($('input#newavail').val().length) {
            if (this.state.curProp == "adminEmails") {
                if (!$('input#newavailemail').val().length) {
                    $('#newavailemail').css('border-color', 'red')
                    return
                }
            }

            var newopt = ''
            var opts = document.getElementById('options')
            var opt = $('input#newavail').val().toLowerCase()

            opt = opt.split(' ')
            opt.map((op) => {
                if (newopt.length) newopt += ' '
                op = op.charAt(0).toUpperCase() + op.substring(1)
                newopt += op
            })

            if (this.state.curProp == "adminEmails") {
                newopt += ";"
                newopt += $('input#newavailemail').val()
            }

            addBidOption.bind(this)(this.state.curProp, newopt)

            $('input#newavail').val('')
            if (this.state.curProp == "adminEmails") {
                $('input#newavailemail').val('')
            }

            setTimeout(function () { opts.size = opts.length }, 100)
        }
    }

    emailChange() {
        if (this.props.bids.fetching) return

        $('#newavailemail').css('border-color', 'initial')
    }

    optSelect(e) {
        if (this.props.bids.fetching) return

        $('li').each(function () {
            $(this).removeClass('selected');
        })
        e.target.className = "selected";
    }

    selAll() {
        if (this.props.bids.fetching) return

        var opts = document.getElementById('options')
        var opts2 = document.getElementById('options2')

        selAllBidOptions.bind(this)(this.state.curProp)

        setTimeout(function () {
            opts.size = opts.length
            if (opts2)
                opts2.size = opts2.length
        }, 200)
    }
    selSel() {
        if (this.props.bids.fetching) return

        let sels;
        let opts = []
        var opts2 = document.getElementById('options2')

        sels = $('select.multibox').val()
 
        if (sels && sels.length) {
            selSelBidOptions.bind(this)(this.state.curProp, sels)

            $('select.multibox').val([]);
        }

        setTimeout(function () {
            if (opts2)
                opts2.size = opts2.length
        }, 200)
    }
    unSel() {
        if (this.props.bids.fetching) return

        let sel;
        var opts = document.getElementById('options')
        var opts2 = document.getElementById('options2')

        sel = $('li.selected');

        if (sel.length) {
            unSelBidOption.bind(this)(this.state.curProp, sel.text())

            sel.removeClass('selected');
        }

        setTimeout(function () {
            opts.size = opts.length
            if (opts2)
                opts2.size = opts2.length
        }, 200)
    }
    unSelAll() {
        if (this.props.bids.fetching) return

        var opts = document.getElementById('options')
        var opts2 = document.getElementById('options2')

        unSelAllBidOptions.bind(this)(this.state.curProp)

        setTimeout(function () {
            opts.size = opts.length
            if (opts2)
                opts2.size = opts2.length
        }, 200)
    }

    selAll2() {
        if (this.props.bids.fetching) return

        var opts = document.getElementById('options2')

        selAllArchiveOptions.bind(this)(this.state.curProp)

        setTimeout(function () { opts.size = opts.length }, 200)
    }
    selSel2() {
        if (this.props.bids.fetching) return

        let sels;
        let opts = []

        sels = $('select#options2').val()

        if (sels && sels.length) {
            selSelArchiveOptions.bind(this)(this.state.curProp, sels)

            $('select#options2').val([]);
        }
    }
    unSel2() {
        if (this.props.bids.fetching) return

        let sel;
        var opts = document.getElementById('options2')

        sel = $('li.selected');

        if (sel.length) {
            unSelArchiveOption.bind(this)(this.state.curProp, sel.text())

            sel.removeClass('selected');
        }

        setTimeout(function () { opts.size = opts.length }, 200)
    }
    unSelAll2() {
        if (this.props.bids.fetching) return

        var opts = document.getElementById('options2')

        unSelAllArchiveOptions.bind(this)(this.state.curProp)

        setTimeout(function () { opts.size = opts.length }, 200)
    }

    onCancel() {
        $('select#types').val('bidStatuses')
        $('.newavail').removeAttr('disabled')

        this.setState({ curProp: 'bidStatuses' })

        fetchBidsMngtList.bind(this)()
        chkReturn = setInterval(this.cancelBids, 100);
    }

    onCancelNotify() {
        fetchBidsMngtList.bind(this)()
        chkReturn = setInterval(this.cancelBids, 100);
    }

    cancelBids() {
        if (this.props.bids.fetched || this.props.bids.error) {
            this.setState({ notify: false })

            if (this.props.bids.fetched) {
                var opts = document.getElementById('options')
                var opts2 = document.getElementById('options2')

                opts.size = opts.length
                if (opts2)
                    opts2.size = opts2.length
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    onSubmit() {
        var bids = Object.assign({}, this.props.bids.bids)

        bids.states.map((state) => {
            state.isBidActive = state.isActive
        })

        bids.adminEmails.map((email) => {
            var data = email.name.split(';')

            email.name = data[0]
            email.active = email.isActive

            if (email.id == -1) {
                email.email = data[1]
                email.bidAdminEmailId = -1
            }
        })

        updateBids.bind(this)(bids)

        chkReturn = setInterval(this.closeBids, 100);
    }

    closeBids() {
        if (this.props.bids.fetched || this.props.bids.error) {
            if (this.props.bids.fetched) {
                this.setState({ notify: true })
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    render() {
        return (
            <div className="bidsmngt col-xs-12">
                <CommError error={this.props.bids.error} onClose={this.fetchBidsMngtErrorClear} />
                <ConfirmModal open={this.state.notify} heading={"Bid Tracker Admin"} msg={"Submit Successful"} notifyOnly={true} onYes={this.onCancelNotify} />

                <div className="headWrapper">
                    <div className="product">
                        <h1>Bid Tracker Admin</h1>
                    </div>
                </div>
                <div className="tableWrapper">
                    {
                        this.props.bids.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                </div>

                <div className="bidsmngt col-sm-8">
                    {
                        this.props.bids.fetching ?
                            <select id="types" disabled>
                                <option value="bidStatuses">Status</option>
                                <option value="states">Project States</option>
                                <option value="cabinetManufacturers">Cabinet Manufacturers</option>
                                <option value="unitTypes">Unit Types</option>
                                <option value="vanityTops">Vanity Tops</option>
                                <option value="kitchenTops">Kitchen Tops</option>
                                <option value="adminEmails">Admin Emails</option>
                            </select>
                        :
                            <select id="types" onChange={this.newProp}>
                                <option value="bidStatuses">Status</option>
                                <option value="states">Project States</option>
                                <option value="cabinetManufacturers">Cabinet Manufacturers</option>
                                <option value="unitTypes">Unit Types</option>
                                <option value="vanityTops">Vanity Tops</option>
                                <option value="kitchenTops">Kitchen Tops</option>
                                <option value="adminEmails">Admin Emails</option>
                            </select>
                    }

                    <div className="selections">
                        <div className="opts-box">
                            <p>Available</p>
                            {
                                this.state.curProp != "adminEmails" ?
                                    <input id="newavail" className="newavail" spellcheck="false" />
                                :
                                    <input id="newavail" placeholder="Enter First and Last Name" className="newavail" spellcheck="false"  />
                            }
                            {
                                this.state.curProp == "adminEmails" ?
                                    <input id="newavailemail" placeholder="Enter Email" className="newavail" onChange={this.emailChange} spellcheck="false"  />
                                :
                                    null
                            }
                            <div className="opts-box-buttons">
                                <button className="multibox btn newavail" onClick={this.addOption}><i className="fa fa-plus"></i></button>
                            </div>

                            {
                                this.props.bids.fetching ?
                                    <select id="options" className="multibox form-control" multiple disabled>
                                        {
                                            this.props.bids.bids[this.state.curProp] ?
                                                this.props.bids.bids[this.state.curProp].filter((prop) => { return !prop.isActive })
                                                    .map((prop) => { return <option>{prop.name}</option> })
                                                : null
                                        }
                                    </select>
                                :
                                    <select id="options" className="multibox form-control" multiple>
                                        {
                                            this.props.bids.bids[this.state.curProp] ?
                                                this.props.bids.bids[this.state.curProp].filter((prop) => { return !prop.isActive })
                                                    .map((prop) => { return <option>{prop.name}</option> })
                                                : null
                                        }
                                    </select>
                            }
                            <div className="opts-box-buttons">
                                <button className="multibox btn" onClick={this.selAll}><i className="fa fa-angle-double-right"></i></button>
                                <button className="multibox btn" onClick={this.selSel}><i className="fa fa-angle-right"></i></button>
                                <button className="multibox btn" onClick={this.unSel}><i className="fa fa-angle-left"></i></button>
                                <button className="multibox btn" onClick={this.unSelAll}><i className="fa fa-angle-double-left"></i></button>
                            </div>
                        </div>

                        <div className="opts-box">
                            <p>Selected</p>
                            <ul className="form-control">
                                {
                                    this.props.bids.bids[this.state.curProp] ?
                                        this.props.bids.bids[this.state.curProp].filter((prop) => { return prop.isActive })
                                            .map((prop) => { return <li onClick={this.optSelect}>{prop.name}</li> })
                                    : null
                                }
                            </ul>
                        </div>
                    </div>

                    {
                        this.state.curProp == 'bidStatuses' ?
                            <div className="selections">
                                <div className="opts-box">
                                    <p>Display as Archive</p>
                                    {
                                        this.props.bids.fetching ?
                                            <select id="options2" className="multibox form-control" multiple disabled>
                                                {
                                                    this.props.bids.bids[this.state.curProp] ?
                                                        this.props.bids.bids[this.state.curProp].filter((prop) => { return prop.isActive && !prop.displayAsActive })
                                                            .map((prop) => { return <option>{prop.name}</option> })
                                                        : null
                                                }
                                            </select>
                                        :
                                            <select id="options2" className="multibox form-control" multiple>
                                                {
                                                    this.props.bids.bids[this.state.curProp] ?
                                                        this.props.bids.bids[this.state.curProp].filter((prop) => { return prop.isActive && !prop.displayAsActive })
                                                            .map((prop) => { return <option>{prop.name}</option> })
                                                        : null
                                                }
                                            </select>
                                    }
                                    <div className="opts-box-buttons">
                                        <button className="multibox btn" onClick={this.selAll2}><i className="fa fa-angle-double-right"></i></button>
                                        <button className="multibox btn" onClick={this.selSel2}><i className="fa fa-angle-right"></i></button>
                                        <button className="multibox btn" onClick={this.unSel2}><i className="fa fa-angle-left"></i></button>
                                        <button className="multibox btn" onClick={this.unSelAll2}><i className="fa fa-angle-double-left"></i></button>
                                    </div>
                                </div>

                                <div className="opts-box">
                                    <p>Display as Active</p>
                                    <ul className="form-control">
                                        {
                                            this.props.bids.bids[this.state.curProp] ?
                                                this.props.bids.bids[this.state.curProp].filter((prop) => { return prop.isActive && prop.displayAsActive })
                                                    .map((prop) => { return <li onClick={this.optSelect}>{prop.name}</li> })
                                                : null
                                        }
                                    </ul>
                                </div>
                            </div>
                        : null
                    }

                    <div className="button-group">
                        <a className="btn btn-default" onClick={this.onCancel}>Cancel</a>
                        <button className="btn btn-primary" onClick={this.onSubmit}>Submit</button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    bids: state.bidsMngt
});

export default connect(mapStateToProps)(Bids)